import { render } from "./CommsPage.vue?vue&type=template&id=1c5854f9&scoped=true"
import script from "./CommsPage.vue?vue&type=script&lang=js"
export * from "./CommsPage.vue?vue&type=script&lang=js"

import "./CommsPage.vue?vue&type=style&index=0&id=1c5854f9&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c5854f9"]])

export default __exports__